import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import "./assets/styles/bootstrap/scss/bootstrap.scss";

import common_pt from "./translations/pt/common.json";
import common_en from "./translations/en/common.json";
import about_pt from './translations/pt/about.json';
import about_en from './translations/en/about.json';
import carousel_pt from './translations/pt/carousel.json';
import carousel_en from './translations/en/carousel.json';
import specialities_pt from './translations/pt/specialities.json';
import specialities_en from './translations/en/specialities.json';
import contacts_pt from './translations/pt/contacts.json';
import contacts_en from './translations/en/contacts.json';
import protocols_pt from './translations/pt/protocols.json';
import protocols_en from './translations/en/protocols.json';

i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: "pt", // language to use
  resources: {
    en: {
      "common": common_en,
      "about": about_en,
      "carousel": carousel_en,
      "specialities" : specialities_en,
      "contacts": contacts_en,
      "protocols": protocols_en
    },
    pt: {
      "common": common_pt,
      "about": about_pt,
      "carousel": carousel_pt,
      "specialities" : specialities_pt,
      "contacts": contacts_pt,
      "protocols": protocols_pt
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
